export const GET_SYSTEM_ALARM_SEUIL = 'GET_SYSTEM_ALARM_SEUIL';
export const SYSTEM_ALARM_SEUIL_UPDATED = 'SYSTEM_ALARM_SEUIL_UPDATED';